import request from './request'

/**
 * 获取图片代理URL
 * @param {string} url - 原始图片URL
 * @returns {Promise} 包含代理后图片URL的Promise
 */
export const getProxyImageUrl = (url) => {
  return request({
    url: '/api/image-proxy',
    method: 'get',
    params: { url }
  })
}
